var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "mb-1" }, [
      _c("div", [
        _c("label", [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.taskData.type_id,
                expression: "taskData.type_id",
              },
            ],
            attrs: { value: "-1", type: "radio" },
            domProps: { checked: _vm._q(_vm.taskData.type_id, "-1") },
            on: {
              change: function ($event) {
                return _vm.$set(_vm.taskData, "type_id", "-1")
              },
            },
          }),
          _vm._v(" запись в черный список без условий"),
        ]),
      ]),
      _vm._v(" "),
      _c("div", [
        _c("label", [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.taskData.type_id,
                expression: "taskData.type_id",
              },
            ],
            attrs: { value: "-2", type: "radio" },
            domProps: { checked: _vm._q(_vm.taskData.type_id, "-2") },
            on: {
              change: function ($event) {
                return _vm.$set(_vm.taskData, "type_id", "-2")
              },
            },
          }),
          _vm._v(" запись в черный список c условиями"),
        ]),
      ]),
    ]),
    _vm._v(" "),
    +_vm.taskData.type_id === -2 ? _c("div", [_vm._m(0)]) : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "mt-1 flex justify-content-end" },
      [
        _c("LoadingButton", {
          attrs: {
            title: "Сохранить",
            loading: _vm.loading,
            color: "white",
            onClick: () => _vm.saveTask(),
            className: "btn btn-success",
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "alert alert-info" }, [
      _c("p", [
        _vm._v("Используйте условия сверху, для добавления в черный список"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }